import React from "react";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import img from "../../images/image 144 (1).png";
import "./payment.css";
import { useNavigate } from "react-router-dom";

const PaymentUnsuccessful = () => {
  const navigate = useNavigate();
  return (
    <div className="payment-status-page">
      <Header />
      <div className="payment-status-container">
        <img src={img} style={{ marginBottom: "40px" }} />
        <h4 style={{ padding: "0", paddingBottom: "10px", margin: "0" }}>
          Currently, Few Products are Out of Stock!
        </h4>
        <h4 style={{ padding: "0", paddingBottom: "10px", margin: "0" }}>
          Do Connect with us & Stay Tuned!
        </h4>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentUnsuccessful;
